import React from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { db } from "firebase/fbConfig.js";
import { Link } from 'react-router-dom'

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Slide from "@material-ui/core/Slide";

// @material-ui/icons
import Close from "@material-ui/icons/Close";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import Search from "@material-ui/icons/Search";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";

import { startSetUsersList } from "store/actions/adminActions"

import AddNewGroupForm from "components/Forms/AddNewGroupForm.jsx"
import Style from "../../assets/jss/material-dashboard-pro-react/views/casesStyle";

const Transition = (props) => {
    return <Slide direction="down" {...props} />
}

class Explore extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataLoaded: false,
            data: [],
            filteredData: [],
            query: '',
            addGroup: false,
        }
    }

    componentDidMount() {
        this.getData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.query !== this.state.query) {
            this.setState(pState => ({
                filteredData: pState.data.filter(group => group.name.includes(this.state.query))
            }));
        }
    }

    getData = async () => {
        const groupsSnap = await db.collection('haney-groups').get();

        const groupData = groupsSnap.docs.map(doc => ({
            ...doc.data(),
            id: doc.id
        }))

        console.log(groupData)

        this.setState({
            data: groupData,
            filteredData: groupData,
            dataLoaded: true
        })
    }

    handleChange = e => {
        this.setState({
            [e.target.id]: e.target.value,
        });
    }

    handleBooleanChange = (name) => {
        this.setState(prevState => ({
            [name]: !prevState[name]
        }));
    }

    render() {
        const { AuthBool, classes, user, path, cases } = this.props;

        return this.state.dataLoaded ? (
            <GridContainer justify='center'>
                <GridItem xs={8}>
                    <div style={{ width: "95%", margin: "0 auto", marginTop: "0px", marginBottom: "0px" }}>
                        <Search style={{ color: "#bbb", marginBottom: "-8px", marginRight: "10px", fontSize: "1rem" }} className={classes.headerLinksSvg + " " + classes.searchIcon} />

                        <CustomInput
                            formControlProps={{
                                className: classes.top + " " + classes.search,
                                style: { width: "85%", paddingTop: "10px" }
                            }}
                            id="query"
                            inputProps={{
                                placeholder: "Search...",
                                onChange: (event) => this.handleChange(event),
                                inputProps: {
                                    "aria-label": "Search",
                                    className: classes.searchInput
                                }
                            }}
                        />
                    </div>
                </GridItem>
                <GridItem>
                    <Button
                        color='primary'
                        onClick={() => this.handleBooleanChange('addGroup')}
                    >
                        ADD NEW GROUP
                    </Button>
                </GridItem>

                <GridItem xs={10}>
                    <GridContainer style={{ minHeight: '100px' }}>
                        {this.state.filteredData.map(d => (
                            <Link to={`/groups/${d.id}`} style={{ color: 'inherit', textDecoration: 'inherit', width: 'inherit' }}>
                                <Card style={{ backgroundColor: "#eee", padding: '8px' }} >
                                    <GridContainer justify='center' alignItems='center'>
                                        <GridItem xs={12}>
                                            <h5 style={{ textAlign: 'center' }}><b>{d.id}</b></h5>
                                        </GridItem>
                                        <GridItem xs={6}>
                                            <h5><b>
                                                {d.name}
                                            </b></h5>
                                        </GridItem>
                                        <GridItem xs={6}>
                                            <p>{d.description}</p>
                                        </GridItem>
                                    </GridContainer>
                                </Card>
                            </Link>
                        ))}
                    </GridContainer>
                </GridItem>
                <Dialog
                    open={this.state.addGroup}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={() => this.handleBooleanChange('addGroup')}
                >

                    <DialogContent
                        className={classes.modalBody}
                    >
                        <Button
                            style={{
                                margin: "0% 1% 0% 0%",
                                color: "black",
                            }}
                            simple
                            className={classes.modalCloseButton}
                            key="close"
                            aria-label="Close"
                            onClick={() => this.handleBooleanChange('addGroup')}
                        >
                            {" "}
                            <Close className={classes.modalClose} />
                        </Button>

                        <AddNewGroupForm />

                    </DialogContent>
                </Dialog>
            </GridContainer>
        ) :
            (
                <p>Loading...</p>
            );
    }
}

const mapStateToProps = (state, ownProps) => {
    console.log(ownProps)
    return {
        AuthBool: !!state.auth.user,
        users: state.admin.users,
        user: state.auth.user,
        // cases: state.cases.cases,
        path: ownProps.match.params.id
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    console.log(this.props)
    return {
        startSetUsersList: dispatch(startSetUsersList()),
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(Style)
)(Explore);


// WEBPACK FOOTER //
// ./src/views/ExploreTemp/ExploreGroups.jsx